/**
 * @debtbot/shared — типы API, zod-схемы, money и balance утилиты,
 * общие для backend и Mini App. Потребляется из исходников: api бандлит через tsup,
 * miniapp — через Vite. Отдельной сборки нет.
 */
export const API_PREFIX = '/api/v1';

export type HealthResponse = {
  status: 'ok' | 'degraded';
  version: string;
  db: 'ok' | 'error';
};

export * from './money';
export * from './api-types';
export * from './schemas';
export * from './links';
export * from './categories';
export * from './locales';
export * from './balance';
